import { useEffect, useRef } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { apiScope } from "../../auth";
import ProgressSpinnerComponent from "./ProgressSpinner";
import LogoutSuccessComponent from "./LogoutSuccess";

const AuthGuardComponent = () => {
  const hasLoggedInRef = useRef(false);
  const { instance, accounts, inProgress } = useMsal();

  const location = useLocation();

  const isLogoutPage = !!matchPath(
    { path: "/logout", end: false },
    location.pathname
  );

  useEffect(() => {
    if (isLogoutPage) return;

    if (inProgress !== "none") return;

    if (accounts.length > 0) return;

    // Prevent a double redirect in development StrictMode once MSAL is ready.
    if (hasLoggedInRef.current) return;
    hasLoggedInRef.current = true;

    instance
      .loginRedirect({ scopes: apiScope })
      .catch((e) => {
        hasLoggedInRef.current = false;
        console.error(e);
      });
  }, [accounts.length, inProgress, instance, isLogoutPage]);

  if (isLogoutPage) {
    return <LogoutSuccessComponent />;
  }

  return <ProgressSpinnerComponent />;
};

export default AuthGuardComponent;
